import React from 'react'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from '@material-ui/core'
import { Dialog } from '@progress/kendo-react-dialogs'
import ButtonHLPure from '../buttonHL/buttonHL.pure'
import LabelModalPure from '../labelModalPure/labelModalPure'
import './dialog-delete-signer.css'

/* === Custom component title for dialog === */
const CustomDeleteSignerTitleBar = (props) => {
    const { t } = useTranslation()
    return (<div><span>{t('dialogDeleteSigner.dialogTittleDeleteSigner')}</span></div>)
}

const DialogDeleteSignerPure = (props) => {
    const { t } = useTranslation()
    const ENV = process.env
    const is560 = useMediaQuery('(max-width:620px)')

    const isValidator = props.signerToDelete && props.signerToDelete.is === 'validator'
    const questionKey = isValidator ? 'dialogDeleteSigner.AreYouShureToDeleteValidator' : 'dialogDeleteSigner.AreYouShureToDeleteSigner'
    const acceptKey = isValidator ? 'dialogDeleteSigner.buttonAcceptValidator' : 'dialogDeleteSigner.buttonAccept'
    const labelQuestion = `${t(questionKey)} (${props.signerToDelete.email}) ${t('dialogDeleteSigner.OfTheSignRequest')}`

    return (
        <div>
            {props.visibleDialogDeleteSigner &&
                <Dialog title={<CustomDeleteSignerTitleBar />} width={is560 ? 300 : 400} height={is560 ? 340 : 270} onClose={props.toggleDialogDeleteSigner} className='dialog-deleteSigner'>
                    <div className='container-dialogDeleteSigner'>
                        <div className='dialogDeleteSigner-container-elements'>
                            <img
                                alt=''
                                src={`${ENV.REACT_APP_ROUTE_BUCKET_AWS}${ENV.REACT_APP_ICON_MODAL_CONFIRMATION}`}
                                className='dialogDeleteSigner-img'
                            ></img>
                            <LabelModalPure label={labelQuestion} />
                        </div>

                        {/* Buttons group */}
                        <div className='group-btns-dialogDeleteSigner'>
                            <ButtonHLPure
                                nameBtn={t('dialogDeleteSigner.buttonCancel')}
                                onClickBtn={props.toggleDialogDeleteSigner}
                                primary={false}
                            />
                            <ButtonHLPure
                                nameBtn={t(acceptKey)}
                                onClickBtn={props.remove}
                                primary={true}
                            />
                        </div>
                    </div>
                </Dialog>
            }
        </div>
    )
}
export { DialogDeleteSignerPure as default }